/* ═══════════════════════════════════════════
   BDRE.NO — Theme JavaScript
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── SCROLL ANIMATIONS ─── */
  function initAnimations() {
    var els = document.querySelectorAll('.animate-in, .stagger-in, .scale-in, .slide-left, .slide-right');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ─── PARALLAX ─── */
  function initParallax() {
    var parallaxEls = document.querySelectorAll('[data-parallax]');
    if (!parallaxEls.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.pageYOffset;
          parallaxEls.forEach(function(el) {
            var rect = el.getBoundingClientRect();
            var center = rect.top + rect.height / 2;
            var viewH = window.innerHeight;
            var offset = (center - viewH / 2) * 0.06;
            el.style.transform = 'translateY(' + offset + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ─── IMAGE GALLERY (swipe + thumbs) ─── */
  function initGallery() {
    var slider = document.querySelector('[data-gallery-slider]');
    var slides = document.querySelectorAll('.product-gallery__slide');
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    var dots = document.querySelectorAll('[data-dot-index]');
    if (!slider || slides.length < 2) return;

    var currentIndex = 0;

    function goToSlide(idx) {
      currentIndex = idx;
      // Desktop: toggle is-active
      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      // Mobile: scroll to slide
      if (window.innerWidth <= 768) {
        slider.scrollTo({ left: idx * slider.offsetWidth, behavior: 'smooth' });
      }
    }

    // Thumb clicks (desktop)
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goToSlide(parseInt(thumb.getAttribute('data-thumb-index')));
      });
    });

    // Dot clicks
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(dot.getAttribute('data-dot-index')));
      });
    });

    // Mobile: detect scroll snap position
    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
        if (idx !== currentIndex && idx >= 0 && idx < slides.length) {
          currentIndex = idx;
          dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
          slides.forEach(function(s, i) { s.classList.toggle('is-active', i === idx); });
          thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
        }
      }, 50);
    }, { passive: true });
  }

  /* ─── CARD BUY BUTTONS ─── */
  function initCardBuyButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__buy-btn');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-product-id');
      if (!vid) return;
      var origText = btn.textContent;
      btn.textContent = 'Legger til...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
      }).then(cartResponse).then(function(item) {
        btn.textContent = '✓ Lagt til!';
        showNotification(item.title || 'Produkt lagt til');
        refreshDrawer(function() { openDrawer(); });
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
      }).catch(function(err) { btn.textContent = origText; btn.disabled = false; showCartError(err); });
    });
  }

  /* ─── QUANTITY SELECTOR (product page) ─── */
  function initQuantity() {
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    var input = document.querySelector('[data-qty-input]');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function() {
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    plus.addEventListener('click', function() {
      input.value = parseInt(input.value, 10) + 1;
    });
  }

  /* ─── VARIANT SELECTOR ─── */
  function initVariants() {
    var variantDataEl = document.querySelector('[data-product-variants]');
    if (!variantDataEl) return;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); if (!Array.isArray(variants)) throw new Error('Invalid variant data'); }
    catch (error) { console.error('Variant selector unavailable', error); return; }
    var selectors = document.querySelectorAll('.variant-selector');
    if (!selectors.length) return;

    function getSelectedOptions() {
      var opts = [];
      selectors.forEach(function(sel) {
        var active = sel.querySelector('.variant-option.is-active');
        opts.push(active ? active.getAttribute('data-option-value') : null);
      });
      return opts;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;
      var idInput = document.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      // Update price
      var priceEl = document.querySelector('.product-info__price-current');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      // Update compare price
      var compareEl = document.querySelector('.product-info__price-compare');
      var badgeEl = document.querySelector('.product-info__price-badge');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (badgeEl) { var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price); badgeEl.textContent = '-' + pct + '%'; badgeEl.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
      // Update add-to-cart button
      var submitBtn = document.querySelector('.product-actions .btn--accent');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Legg i handlekurv' : 'Utsolgt';
      }
      // Update sticky ATC
      var stickyPrice = document.querySelector('.sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? 'Legg i handlekurv' : 'Utsolgt'; }
    }

    selectors.forEach(function(sel) {
      sel.querySelectorAll('.variant-option').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var siblings = btn.parentNode.querySelectorAll('.variant-option');
          siblings.forEach(function(s) { s.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updateVariant();
        });
      });
    });
  }

  /* ═══════════════════════════════════════
     CART DRAWER
     ═══════════════════════════════════════ */

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  var cartReturnFocus = null;
  function openDrawer() {
    if (!drawer || !overlay) return;
    if (!drawer.classList.contains('is-open')) cartReturnFocus = document.activeElement;
    drawer.inert = false;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('cart-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-modal', 'true');
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus({preventScroll:true});
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    if (!document.querySelector('.mobile-menu.is-open')) document.body.style.overflow = '';
    if (drawer.contains(document.activeElement)) {
      if (cartReturnFocus && cartReturnFocus.isConnected && !cartReturnFocus.disabled) cartReturnFocus.focus({preventScroll:true});
      if (drawer.contains(document.activeElement)) document.activeElement.blur();
    }
    drawer.inert = true;
    drawer.removeAttribute('aria-modal');
    drawer.setAttribute('aria-hidden', 'true');
  }

  window.addEventListener('pagehide', closeDrawer);
  window.addEventListener('pageshow', function() {
    closeDrawer();
    var header = document.querySelector('.site-header');
    if (header) header.classList.remove('site-header--hidden');
  });

  function initCartDrawer() {
    // Open buttons
    var openBtns = document.querySelectorAll('[data-cart-open]');
    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-close], [data-cart-overlay]')) {
        if (!e.target.closest('a[href]')) e.preventDefault();
        closeDrawer();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); }
      if (e.key === 'Tab') {
        var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')).filter(function(el){ return el.getClientRects().length && !el.closest('[inert]'); });
        var first = focusable[0], last = focusable[focusable.length-1];
        if (!first) { e.preventDefault(); drawer.focus(); }
        else if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });

    // Quantity change buttons in drawer
    initDrawerQtyButtons();
  }

  function initDrawerQtyButtons() {
    var qtyBtns = document.querySelectorAll('[data-change-qty]');
    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        changeCartQty(key, Math.max(0, qty));
      });
    });
  }

  /* ─── AJAX: Change quantity in cart ─── */
  function changeCartQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(cartResponse)
    .then(function() {
      refreshDrawer();
    })
    .catch(function(err) {
      showCartError(err);
    });
  }

  /* ─── AJAX: Add to cart ─── */
  var addPending = false;
  function addToCart(body, source, form) {
    if (addPending || (source && source.disabled)) return Promise.resolve(null);
    addPending = true;
    var buttons = Array.from(document.querySelectorAll('[data-sticky-atc-btn]'));
    if (form) buttons = buttons.concat(Array.from(form.querySelectorAll('[type="submit"]')));
    if (source && buttons.indexOf(source) < 0) buttons.push(source);
    var states = buttons.map(function(b) { return {button:b, text:b.textContent, disabled:b.disabled}; });
    states.forEach(function(s) { s.button.disabled = true; s.button.textContent = 'Legger til...'; });
    var oldError = document.querySelector('[data-cart-error]');
    if (oldError) oldError.remove();
    var options = {method:'POST', body:body};
    if (!(body instanceof FormData)) { options.headers = {'Content-Type':'application/json'}; options.body = JSON.stringify(body); }
    return fetch('/cart/add.js', options).then(cartResponse).then(function(item) {
      showNotification(item.title || 'Produkt');
      return refreshDrawer(function() { openDrawer(); });
    }).catch(function(error) {
      // Never retry an uncertain mutation: Shopify may already have added it.
      showCartError(error);
      return null;
    }).finally(function() {
      addPending = false;
      states.forEach(function(s) { s.button.disabled = s.disabled; s.button.textContent = s.text; });
    });
  }
  function addProduct(source) {
    var main = document.querySelector('.product-actions .btn--accent');
    var form = main && main.closest('form');
    if (!form || !main || main.disabled || !form.reportValidity()) return;
    return addToCart(new FormData(form), source || main, form);
  }
  window.BdreCart = {add:addToCart, addProduct:addProduct, close:closeDrawer};
  function initAjaxAddToCart() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var button = form.querySelector('[type="submit"]');
        if (!form.reportValidity()) return;
        addToCart(new FormData(form), button, form);
      });
    });
  }

  /* ─── Refresh cart drawer via AJAX ─── */
  function cartResponse(response) {
    return response.json().then(function(data) {
      if (!response.ok) {
        throw new Error(typeof data.description === 'string' ? data.description : 'Kunne ikke oppdatere handlekurven. Prøv igjen.');
      }
      return data;
    });
  }

  function showCartError(error) {
    var box = document.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-cart-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'cart-error-notice';
      document.body.appendChild(box);
    }
    box.textContent = error && error.message ? error.message : 'Kunne ikke oppdatere handlekurven. Prøv igjen.';
    var link = document.createElement('a');
    link.href = '/cart';
    link.textContent = 'Åpne handlekurven';
    box.appendChild(link);
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Lukk';
    close.onclick = function() { box.remove(); };
    box.appendChild(close);
  }

  function refreshDrawer(callback) {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(cartResponse)
      .then(function(cart) {
        updateDrawerFromCart(cart);
        checkGiftEligibility(cart);
        if (callback) callback();
        return cart;
      })
      .catch(function() {
        showCartError(new Error('Handlekurven kunne ikke vises akkurat nå. Åpne handlekurven for å kontrollere innholdet.'));
        return null;
      });
  }

  /* ─── Update drawer DOM from cart JSON ─── */
  function updateDrawerFromCart(cart) {
    // Update count badges
    var counts = document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]');
    counts.forEach(function(el) { el.textContent = cart.item_count; });

    // Update header cart total display
    var totalDisplays = document.querySelectorAll('[data-cart-total-display]');
    totalDisplays.forEach(function(el) { el.textContent = formatMoney(cart.total_price); });

    // Update total
    var totals = document.querySelectorAll('[data-cart-total]');
    totals.forEach(function(el) { el.textContent = formatMoney(cart.total_price); });

    // Update milestones
    updateMilestones(cart.total_price, cart.item_count);

    // Rebuild items (full HTML rebuild via section rendering)
    var itemsContainer = document.querySelector('[data-cart-items]');
    var footerContainer = document.querySelector('.cart-drawer__footer');

    if (cart.item_count === 0) {
      if (itemsContainer) {
        itemsContainer.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<div style="font-size: 40px; margin-bottom: 12px;">🛒</div>' +
            '<p>Handlekurven din er tom</p>' +
            '<a href="/collections/all" class="btn btn--primary" style="margin-top: 16px;" data-cart-close>Se alle produkter</a>' +
          '</div>';
      }
      if (footerContainer) footerContainer.style.display = 'none';
      var recsWrap = document.querySelector('[data-cart-recs-wrap]');
      if (recsWrap) recsWrap.style.display = 'none';
    } else {
      // Rebuild items HTML
      var html = '';
      var giftSelector = document.querySelector('[data-gift-selector]');
      var giftVariantId = giftSelector ? parseInt(giftSelector.getAttribute('data-gift-variant'), 10) : 0;

      cart.items.forEach(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2') : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var isGift = item.variant_id === giftVariantId;

        if (isGift) {
          // Gift items are shown in the gift selector, not in the item list
          return;
        }

        html +=
          '<div class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
            '<a href="' + item.url + '" class="cart-drawer__item-image">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" width="80" height="80" loading="lazy">' : '') +
            '</a>' +
            '<div class="cart-drawer__item-info">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
              (variantTitle ? '<div class="cart-drawer__item-variant">' + variantTitle + '</div>' : '') +
              '<div class="cart-drawer__item-bottom">' +
                '<div class="cart-drawer__item-qty">' +
                  '<button type="button" data-change-qty data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-change-qty data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
                '</div>' +
                '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-change-qty data-key="' + item.key + '" data-qty="0" aria-label="Fjern">✕</button>' +
          '</div>';
      });

      if (itemsContainer) itemsContainer.innerHTML = html;
      if (footerContainer) {
        footerContainer.style.display = '';
        var totalEl = footerContainer.querySelector('[data-cart-total]');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      }
      var recsWrap = document.querySelector('[data-cart-recs-wrap]');
      if (recsWrap) {
        recsWrap.style.display = '';
        loadCartRecs(cart);
      }

      // Re-attach qty listeners
      initDrawerQtyButtons();


    }
  }

  /* ─── Notification toast ─── */
  function showNotification(title) {
    // Remove old
    var old = document.querySelector('.cart-notification');
    if (old) old.remove();

    var el = document.createElement('div');
    el.className = 'cart-notification';
    el.innerHTML = '<div class="cart-notification__check">✓</div><span>' + title + ' lagt i handlekurven</span>';
    document.body.appendChild(el);

    requestAnimationFrame(function() {
      el.classList.add('is-visible');
    });

    setTimeout(function() {
      el.classList.remove('is-visible');
      setTimeout(function() { el.remove(); }, 400);
    }, 3000);
  }

  /* ─── Update dual progress bars ─── */
  function updateMilestones(totalPrice, itemCount) {
    var shippingThreshold = parseInt(document.body.getAttribute('data-free-shipping') || '100000', 10);
    var giftSelector = document.querySelector('[data-gift-selector]');
    var giftQtyThreshold = giftSelector ? parseInt(giftSelector.getAttribute('data-gift-qty-threshold') || '4', 10) : 4;
    var pctShipping = Math.min(Math.round((totalPrice / shippingThreshold) * 100), 100);
    var pctGift = Math.min(Math.round((itemCount / giftQtyThreshold) * 100), 100);

    // Update fill bars
    var shippingFill = document.querySelector('[data-shipping-fill]');
    if (shippingFill) shippingFill.style.width = pctShipping + '%';
    var giftFill = document.querySelector('[data-gift-fill]');
    if (giftFill) giftFill.style.width = pctGift + '%';

    // Update side complete state
    var leftSide = document.querySelector('.cart-dual-progress__side--left');
    var rightSide = document.querySelector('.cart-dual-progress__side--right');
    if (leftSide) leftSide.classList.toggle('is-complete', pctShipping >= 100);
    if (rightSide) rightSide.classList.toggle('is-complete', pctGift >= 100);

    // Update center dot
    var center = document.querySelector('[data-dual-center]');
    if (center) {
      if (pctShipping >= 100 && pctGift >= 100) {
        center.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        center.style.background = '#2D8F4E';
      } else {
        center.innerHTML = '';
        center.style.background = '#eee';
      }
    }

    // Update shipping label
    var shippingLabel = document.querySelector('[data-shipping-label]');
    var shippingRemaining = document.querySelector('[data-shipping-remaining]');
    if (shippingLabel) shippingLabel.classList.toggle('is-reached', pctShipping >= 100);
    if (shippingRemaining) {
      if (pctShipping >= 100) {
        shippingRemaining.textContent = 'Opptjent!';
        shippingRemaining.classList.add('cart-dual-progress__label-sub--done');
      } else {
        shippingRemaining.textContent = formatMoney(shippingThreshold - totalPrice) + ' igjen';
        shippingRemaining.classList.remove('cart-dual-progress__label-sub--done');
      }
    }

    // Update gift label
    var giftLabel = document.querySelector('[data-gift-label]');
    var giftRemaining = document.querySelector('[data-gift-remaining]');
    if (giftLabel) giftLabel.classList.toggle('is-reached', pctGift >= 100);
    if (giftRemaining) {
      if (pctGift >= 100) {
        giftRemaining.textContent = 'Opptjent!';
        giftRemaining.classList.add('cart-dual-progress__label-sub--done');
      } else {
        giftRemaining.textContent = (giftQtyThreshold - itemCount) + ' produkter igjen';
        giftRemaining.classList.remove('cart-dual-progress__label-sub--done');
      }
    }

    // Show/hide gift selector based on item count
    if (giftSelector) {
      giftSelector.style.display = (itemCount >= giftQtyThreshold) ? '' : 'none';
    }
  }

  /* ─── Gift selector ─── */
  function initGiftSelector() {
    // Claim gift button
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-claim-gift]');
      if (!btn) return;
      var selector = document.querySelector('[data-gift-selector]');
      if (!selector) return;
      var variantId = selector.getAttribute('data-gift-variant');
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Legger til...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { '_gift': 'true' } }] })
      })
      .then(cartResponse)
      .then(function() {
        refreshDrawer();
      })
      .catch(function(err) {
        btn.disabled = false;
        btn.textContent = 'Legg til';
        showCartError(err);
      });
    });
  }

  /* ─── Auto-remove gift if below threshold ─── */
  function checkGiftEligibility(cart) {
    var selector = document.querySelector('[data-gift-selector]');
    if (!selector) return;
    var giftVariantId = selector.getAttribute('data-gift-variant');
    if (!giftVariantId) return;
    giftVariantId = parseInt(giftVariantId, 10);
    var qtyThreshold = parseInt(selector.getAttribute('data-gift-qty-threshold') || '4', 10);

    // Calculate item count excluding the gift item itself
    var countWithoutGift = 0;
    var giftKey = null;
    cart.items.forEach(function(item) {
      if (item.variant_id === giftVariantId) {
        giftKey = item.key;
      } else {
        countWithoutGift += item.quantity;
      }
    });

    // If gift is in cart but count (without gift) is below threshold, remove it
    if (giftKey && countWithoutGift < qtyThreshold) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftKey, quantity: 0 })
      })
      .then(cartResponse)
      .then(function() { refreshDrawer(); })
      .catch(showCartError);
    }
  }

  /* ─── Load cart recommendations ─── */
  function loadCartRecs(cart) {
    var recsEl = document.querySelector('[data-cart-recs]');
    if (!recsEl) return;
    recsEl.innerHTML = '';
    if (!cart || !cart.items || !cart.items.length) return;
    var productId = cart.items[0].product_id;
    if (!productId) return;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(cartResponse)
      .then(function(data) {
        if (!data.products || !data.products.length) return;
        var html = '';
        data.products.forEach(function(p) {
          if (cart.items.some(function(item) { return item.product_id === p.id; })) return;
          var availableVariant = p.variants && p.variants.find(function(v) { return v.available; });
          if (!availableVariant) return;
          var img = p.featured_image ? '<img src="' + p.featured_image + '&width=200" width="80" height="80" loading="lazy">' : '';
          var price = formatMoney(availableVariant.price);
          var variantId = availableVariant.id;
          html += '<div class="cart-drawer__rec-card">'
            + '<a href="' + p.url + '" class="cart-drawer__rec-image">' + img + '</a>'
            + '<div class="cart-drawer__rec-info">'
            + '<a href="' + p.url + '" class="cart-drawer__rec-name">' + p.title.substring(0, 50) + '</a>'
            + '<div class="cart-drawer__rec-price">' + price + '</div>'
            + '<button type="button" class="cart-drawer__rec-btn" data-add-rec="' + variantId + '">Kjøp nå</button>'
            + '</div></div>';
        });
        recsEl.innerHTML = html;
      })
      .catch(function() {});
  }

  /* ─── Add-to-cart from recommendations ─── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-rec]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-add-rec');
    if (!variantId) return;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(cartResponse)
    .then(function() { btn.textContent = 'Lagt til ✓'; refreshDrawer(); })
    .catch(function(err) { btn.textContent = 'Kjøp nå'; btn.disabled = false; showCartError(err); });
  });

  /* ─── Format money (øre to kr) ─── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('nb-NO', {style:'currency', currency:window.Shopify && Shopify.currency ? Shopify.currency.active : 'NOK', minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100);
  }

  /* ─── Bundle Tier Selector ─── */
  function initBundleTiers() {
    var container = document.querySelector('[data-bundle-tiers]');
    if (!container) return;

    container.addEventListener('click', function(e) {
      var tier = e.target.closest('[data-bundle-tier]');
      if (!tier) return;

      // Update active state
      container.querySelectorAll('[data-bundle-tier]').forEach(function(t) {
        t.classList.remove('bundle-tier--active');
      });
      tier.classList.add('bundle-tier--active');

      // Update quantity input
      var qty = parseInt(tier.getAttribute('data-tier-qty'), 10);
      var qtyInput = document.querySelector('[data-qty-input]');
      if (qtyInput) qtyInput.value = qty;
    });
  }

  /* ─── INIT ─── */
  function initTheme() {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    [initAnimations, initParallax, initCardBuyButtons, initGallery, initQuantity, initVariants, initCartDrawer, initGiftSelector, initAjaxAddToCart, initBundleTiers].forEach(function(init) {
      try { init(); } catch (error) { console.error('Theme module failed: ' + init.name, error); }
    });

    // Store free shipping threshold on body for JS access
    var freeShipEl = document.body.getAttribute('data-free-shipping');
    if (!freeShipEl) {
      document.body.setAttribute('data-free-shipping', '100000');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTheme);
  else initTheme();

})();

